const preTitle = `
    <h3 class="c9" dir="rtl" id="reviewsOnHerBooks">
        <span class="c2">בקורת על ספריה עם צאתם לאור</span>
    </h3>
`;

export default preTitle;
